














Vue.use require('element-ui/lib/tooltip').default
import 'vue-awesome/icons/question'
import 'vue-awesome/icons/regular/question-circle'

export default
  name: 'help_tooltip'
  props: ['title', 'id', 'link']
  computed:
    visible: -> !@$store.getters.hidden_tooltips.includes(@id)
  mounted: ->
    # For some reason it's set to 0 automatically, probably by el-tooltip library
    $('.help_tooltip_icon').attr('tabindex', '-1')
  methods:
    hide: -> @$store.dispatch 'hideTooltip', @id

